import React from 'react';
import { get, isEmpty, map, find } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { CardElement } from '@stripe/react-stripe-js';

import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  CircularProgress,
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Radio,
} from '@material-ui/core';
import { CreditCard } from '@material-ui/icons';
import CheckIcon from '@material-ui/icons/Check';
import { loadTexts } from '../../config/texts';

const TEXT_KEY = "subsidy";

class AddCredits extends React.Component {
  state = {
    amount: 0,
    name: '',
    subsidy: get(this, 'props.subsidies.0._id'),
    paymentLoading: false,
    mode: 'input',
    selectedValue: '',
    showAddCard: false,
    texts: loadTexts(TEXT_KEY, this.props.locale)
  };

  componentDidMount() {
    const { cards } = this.props;
    const defaultCard = isEmpty(cards) ? '' : find(cards[0].cards, c => c.default);
    if (!isEmpty(defaultCard)) this.setState({ selectedValue: defaultCard.id });
  }

  _onClickAdd = async () => {
    const { stripe, elements, currency, onSubmit } = this.props;
    const { name, amount, subsidy } = this.state;
    this.props.clearPaymentStatus();

    if (!stripe || !elements) return;

    this.setState({ paymentLoading: true });

    const cardElement = elements.getElement(CardElement);

    const result = await stripe.createToken(cardElement);
    if (result.error) {
      alert(result.error.message);
      this.setState({ paymentLoading: false });
      return;
    }

    if (!onSubmit) return Promise.resolve();

    const stateParams = { paymentLoading: false };
    try {
      await onSubmit({
        token: result.token.id,
        amount,
        currency,
        subsidy,
      });
      // Clear amount field
      stateParams.amount = 0;
      stateParams.mode = 'input';
    } catch (error) {
      throw error;
    } finally {
      this.setState(stateParams);
    }
  };

  _onChangeSubsidy = event => {
    this.setState({ subsidy: event.target.value });
  };

  _onClickBack = () => this.setState({ mode: 'input' });

  button = (mode, params) => {
    const { texts: { credits: { button_text } } } = this.state;
    const buttonParams = {};
    switch (mode) {
      case 'input':
        buttonParams.text = button_text.review_info;
        buttonParams.disabled = params.amount <= 0 || !params.name || params.paymentLoading;
        buttonParams.onClick = () => this.setState({ mode: 'review' });
        break;
      case 'review':
        buttonParams.text = button_text.purchase;
        buttonParams.disabled = params.paymentLoading;
        buttonParams.onClick = this._onClickAdd;
        break;
      default:
        return buttonParams;
    }
    return buttonParams;
  };

  renderReviewRow = (classes, item, value) => (
    <div className={classes.reviewRow}>
      <Typography>
        {`${item}:`}
      </Typography>
      <Typography variant="caption">
        {value}
      </Typography>
    </div>
  );

  renderCards() {
    const { cards, classes } = this.props;
    let cardArray = isEmpty(cards[0]) ? [] : cards[0].cards;

    if (!isEmpty(cardArray)) return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        {map(cardArray, c => (
          <div className={classes.cardsContainer}>
            <div className={classes.subsidyPriceContainer}>
              <CreditCard style={{ marginRight: 5 }}/>
              <Typography>
                {c.name}
              </Typography>
              <div className={classes.subsidyPriceContainer} style={{ marginLeft: 20 }}>
                {map(Array(12), i => (
                  <div style={{ width: 4, height: 4, borderRadius: 2, backgroundColor: 'black', marginRight: 5 }} />
                ))}
              </div>
              <Typography>
                {c.last4}
              </Typography>
            </div>
            <Radio
              checked={this.state.selectedValue === c.id}
              color="primary"
              value={c.id}
              onChange={event => {
                this.setState({ selectedValue: event.target.value });
                this.props.onChangeDefaultCard(c.id)
              }}
            />
          </div>
        ))}
      </div>
    )
  }

  render() {
    const { amount, name, subsidy, paymentLoading, mode, showAddCard, texts } = this.state;
    const { currency, classes, subsidies, paymentStatus, cards, stripe, elements } = this.props;
    const buttonParams = this.button(mode, { amount, name, paymentLoading });
    // console.log(cards);
    // console.log(isEmpty(cards))
    return (
      <div className={classes.container}>
        { !isEmpty(cards) && (
          <div className={classes.subsidyPriceContainer}>
            <TextField
              variant="outlined"
              margin="dense"
              required
              name="amount"
              label={`${texts.credits.label.amount} ${currency.toUpperCase()} ex: 10.50`}
              value={amount}
              id="amount"
              type="number"
              onChange={event => this.setState({ amount: event.target.value })}
            />
          </div>
        )}
        {this.renderCards()}
        {
          (isEmpty(cards) || (!isEmpty(cards) && showAddCard)) && (
          <TextField
            variant="outlined"
            margin="dense"
            required
            name="name"
            label={texts.card.holder}
            value={name}
            id="name"
            onChange={event => this.setState({ name: event.target.value })}
          />
        )}
        {
          (isEmpty(cards) || (!isEmpty(cards) && showAddCard)) && (
          <div className={classes.cardContainer}>
            <CardElement
              options={{
                style: {
                  base: {
                    color: '#32325d',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                      color: '#aab7c4'
                    }
                  },
                  invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                  }
                },
              }}
            />
          </div>
        )}
       <Typography
          color="secondary"
          component="a"
          href="https://stripe.com"
          target="_blank"
        >
          {`⚠ ${texts.credits.stripe}`}
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            color="primary"
            variant="contained"
            onClick={async () => {
              if (isEmpty(cards) || (!isEmpty(cards) && showAddCard)) {
                const cardElement = elements.getElement(CardElement);
                const result = await stripe.createToken(cardElement, { name });
                if (result.error) {
                  alert(result.error.message);
                  this.setState({ paymentLoading: false });
                  return;
                }
                this.props.onAddCard(result.token.id)
              } else this.setState({ showAddCard: true });
            }}
            disabled={false}
          >
            {texts.button_text.add_card}
          </Button>
          <Button
            color="primary"
            variant="contained"
            style={{ marginRight: 10 }}
            onClick={() => {
              this.props.onPurchase(amount)
            }}
            disabled={amount <= 0}
          >
            {texts.button_text.purchase}
          </Button>
          {paymentLoading && (
            <CircularProgress className={classes.loader} />
          )}
          {paymentStatus === 'success' && (
            <CheckIcon color="primary" classes={{ colorPrimary: 'green' }} />
          )}
        </div>
      </div>
    );
  }
}

const styles = theme => ({
  container: {
  },
  cardsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 4,
    backgroundColor: '#C4C4C4',
    padding: 5,
    marginBottom: 10,
  },
  subsidyPriceContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardContainer: {
    borderBottom: '1px solid grey',
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  loader: {
    marginRight: theme.spacing.unit,
  },
  reviewRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  backButton: {
    marginRight: theme.spacing.unit,
  },
});

const mapStateToProps = state => ({
  locale: state.appState.locale,
});

export default compose(
  withStyles(styles, { name: 'AddCredits' }),
  connect(mapStateToProps, {})
)(AddCredits);



// WEBPACK FOOTER //
// ./src/modules/subsidy/AddCredits.js